import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, User, Globe, Menu, X, ChevronDown } from "lucide-react";
import { CONTACT_NUMBER } from "../mock";
import { Button } from "./ui/button";

const navItems = [
  { label: "Hotels", href: "/hotels" },
  { label: "Destinations", href: "/destinations" },
  { label: "Offers", href: "/offers" },
  { label: "AIP Rewards", href: "/rewards" },
  { label: "Meetings & Events", href: "/meetings" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-white/95 backdrop-blur"
      }`}
    >
      {/* Top strip */}
      <div className="hidden md:block border-b border-neutral-100">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-end gap-6 text-xs text-neutral-600">
          <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, "")}`} className="flex items-center gap-1.5 hover:text-[#c8102e] transition-colors">
            <Phone size={13} /> {CONTACT_NUMBER}
          </a>
          <button className="flex items-center gap-1 hover:text-[#c8102e] transition-colors">
            <Globe size={13} /> English (US) <ChevronDown size={12} />
          </button>
          <Link to="/my-booking" className="hover:text-[#c8102e] transition-colors">My Booking</Link>
          <Link to="/admin/bookings" className="hover:text-[#c8102e] transition-colors">Reservations Desk</Link>
          <Link to="/help" className="hover:text-[#c8102e] transition-colors">Help</Link>
        </div>
      </div>

      {/* Main nav */}
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 bg-[#c8102e] flex items-center justify-center rounded-sm">
              <span className="text-white font-bold text-lg tracking-tight">A</span>
            </div>
            <div className="leading-tight">
              <div className="text-xl font-semibold tracking-tight text-neutral-900">AIP Booking</div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">Hospitality Group</div>
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.href}
              className="text-sm font-medium text-neutral-800 hover:text-[#c8102e] transition-colors relative group"
            >
              {item.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#c8102e] transition-all duration-300 group-hover:w-full" />
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button variant="ghost" className="hidden md:flex items-center gap-2 text-neutral-800 hover:text-[#c8102e] hover:bg-transparent">
            <User size={16} /> Sign In / Join
          </Button>
          <Button className="hidden md:inline-flex bg-[#c8102e] hover:bg-[#a70d26] text-white rounded-none px-5">
            Book Now
          </Button>
          <button className="lg:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-neutral-100 bg-white">
          <nav className="flex flex-col px-6 py-4 gap-4">
            {navItems.map((item) => (
              <Link key={item.label} to={item.href} className="text-neutral-800 font-medium" onClick={() => setMobileOpen(false)}>
                {item.label}
              </Link>
            ))}
            <div className="border-t pt-4 flex flex-col gap-3">
              <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, "")}`} className="flex items-center gap-2 text-sm text-neutral-700">
                <Phone size={14} /> {CONTACT_NUMBER}
              </a>
              <Button className="bg-[#c8102e] hover:bg-[#a70d26] text-white rounded-none">Book Now</Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
